import Splide from '@splidejs/splide';

export default class RoomSlider {

    getCarouselOptions(container) {

        new Splide(container, {
            type: 'loop',
            autoplay: true,
            interval: 3000,
            lazyLoad: true,
            easing: 'ease',
            drag: true,
            pagination: true,
            arrows: false,
            perPage: 1,
            perMove: 1,
            autoHeight: true,
        }).mount();

    }

    triggerCarousel() {
        const blocks = document.querySelectorAll(".accommodation-details--slider");
        if (blocks.length) {
            blocks.forEach((block) => {
                const slider = block.querySelector(".splide");
                if (slider) {
                    this.getCarouselOptions(slider);
                }
            });
        }
    }

    init() {
        this.triggerCarousel();
    }
}
